import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {LocalStorage} from '@ngx-pwa/local-storage';
import {map, tap} from 'rxjs/operators';
import {TokenService} from '../../services/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    protected localStorage: LocalStorage,
    protected tokenService: TokenService,
  ) {
  }

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkPermission(route);
  }

  private checkPermission(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.tokenService.getAccessToken().pipe(
      map(data => !!data),
      tap(data => {
        if (!data) {
          this.router.navigate(['/auth']).then();
        }
      }),
    );
  }
}
